import { useEffect, useState } from "react";
import { CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Tooltip } from "antd";
// import RosieAILogo from "../../assets/images/rosie_ai_logo.png";
import RosieAILogo from "../../assets/images/Rosie1.1.png";
import {
  clearRosiePendingFlags,
  markRosiePromptShown,
} from "../../utils/rosieNewSite";


const RosiePopup = ({
  micrositeId,
  rosiePopup,
  setRosiePopup,
  generatingAI,
  progress,
  isNewlyCreatedMicroSite,
  handleGenerateAIApi,
  isBtnDisabled
}) => {
  // Parent progress state can stay true after Site Tabs opens.
  // Close here so the already-open popup cannot stay above Missing Tabs.
  const [closedForMissingTabs, setClosedForMissingTabs] = useState(
    () => localStorage.getItem("rosieAiComplete") === "true",
  );

  useEffect(() => {
    const onMissingTabsOpen = () => setClosedForMissingTabs(true);
    const onMissingTabsClose = (event) => {
      if (event?.detail?.allowNewRosiePrompt === true) {
        setClosedForMissingTabs(false);
      }
    };

    window.addEventListener("missing-tabs-modal-open", onMissingTabsOpen);
    window.addEventListener("missing-tabs-modal-close", onMissingTabsClose);
    return () => {
      window.removeEventListener("missing-tabs-modal-open", onMissingTabsOpen);
      window.removeEventListener("missing-tabs-modal-close", onMissingTabsClose);
    };
  }, []);

  return (
    <Modal
      open={!!rosiePopup && !closedForMissingTabs}
      getContainer={() => document.body}
      zIndex={1100}
      footer={null}
      centered
      closable={false}
      maskClosable={false}
      destroyOnClose
      onCancel={() => {
        clearRosiePendingFlags();
        markRosiePromptShown(micrositeId);
        setRosiePopup(false);
      }}
      className="rosie-ai-popup-container"
    >
      <div style={{ textAlign: "center" }}>
        <div className="rosie-ai-logo-wrapper">
          <div className="rosie-ai-logo" style={{ cursor: "default" }}>
            <img src={RosieAILogo} alt="Generate AI" />
          </div>
        </div>

        {generatingAI?.micrositeID === micrositeId && generatingAI?.isGeneratingData && (
          <div>
            <div className="custom-progress-container">
              <div className="progress-header">
                <span className="progress-status">Generating a draft site</span>
              </div>
              <div className="custom-progress-bar">
                <div
                  className="custom-progress-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>

              <div className="progress-header">
                <span className="progress-percent">{progress}%</span>
              </div>
            </div>
          </div>
        )}

        {/* {generatingAI?.micrositeID !== micrositeId && generatingAI?.isGeneratingData && (
          <h5 className="popup-message" style={{fontSize: "17px"}}>
            AI is already generating data for another microsite. Please wait until the current process is completed.
          </h5>
        )} */}

        {isNewlyCreatedMicroSite && !generatingAI?.isGeneratingData ? (
          <>
            <div className="popup-info-icon-wrapper">
              <Tooltip
                color="#000000"
                overlayClassName="rosie-info-tooltip"
                overlayInnerStyle={{ fontWeight: 600 }}
                title="Rosie is designed to save your time, but don’t be surprised if some content is missing and mistakes are spotted"
              >
                <InfoCircleOutlined className="popup-info-icon" />
              </Tooltip>
            </div>

            <h4 className="popup-message">
              Would you like a one off chance for Rosie to create a draft site
              for you?
            </h4>

            <div className="popup-button-wrapper">
              <Button
                danger
                size="large"
                className="btn-no"
                onClick={() => {
                  clearRosiePendingFlags();
                  markRosiePromptShown(micrositeId);
                  setRosiePopup(false);
                }}
              >
                NO
              </Button>

              <Button
                type="primary"
                size="large"
                className="btn-yes"
                loading={isBtnDisabled}
                disabled={generatingAI?.isBtnDisabled}
                onClick={(e) => {
                  handleGenerateAIApi();
                }}
              >
               {isBtnDisabled ? "Thinking..." : "YES"}
              </Button>
            </div>
          </>
        ) : (
          <div className="popup-info-icon-wrapper">
            <CloseCircleOutlined
              className="popup-info-icon"
              onClick={() => setRosiePopup(false)}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default RosiePopup;
